// Shared, pure formatting helpers for the orderSpy waitlist surfaces (the live
// table and the History cell dialog render orders identically).

/** Em dash, used as the empty-cell placeholder in every orderSpy table. */
export const EMPTY_CELL = "—";

/** Renders an ISO timestamp in the viewer's locale as "Mon D, h:mm AM". */
export function fmtTime(iso: string | null | undefined): string {
  if (!iso) return EMPTY_CELL;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

/** Status badge classes. Colour is paired with the status label text, never
 *  carried alone. Unknown values fall back to a neutral style rather than
 *  breaking (spec 4.2). */
export function statusBadgeClass(status: string | undefined): string {
  const s = (status || "").trim().toLowerCase();
  switch (s) {
    case "waiting":
      return "bg-status-info/15 text-status-info";
    case "making":
      return "bg-status-caution/25 text-status-caution-foreground";
    case "cooking":
      return "bg-status-warning/15 text-status-warning";
    case "ready":
      return "bg-status-success/15 text-status-success";
    case "canceled":
      return "bg-status-danger/15 text-status-danger";
    default:
      return "bg-muted text-muted-foreground";
  }
}
